export default __webpack_public_path__ + "02bb9e5b2e504b18d677b45d8a3b0355.png";